module.exports = __webpack_public_path__ + "4598a9c863547dd9af90d559b02efdc8.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/fr2.pdf
// module id = 928
// module chunks = 3